import {gsap} from "../lib/gsap";
import {ScrollTrigger} from "../lib/gsap/ScrollTrigger";
import {SplitText} from "../lib/gsap/SplitText";
import {Observer} from "../lib/gsap/Observer";
import {Draggable} from "../lib/gsap/Draggable";
import Lenis from "../lib/lenis/lenis.esm.js";

import PhotoSwipeLightbox from "../lib/photoswipe/photoswipe-lightbox.esm.min.js";
import PhotoSwipeDynamicCaption from "../lib/photoswipe/photoswipe-dynamic-caption-plugin.esm.js";
import PhotoSwipe from "../lib/photoswipe/photoswipe.esm.min.js";

gsap.registerPlugin(ScrollTrigger, SplitText, Observer, Draggable);

export {ScrollTrigger};
export {SplitText};
export {Observer};
export {Draggable};
export {PhotoSwipeLightbox, PhotoSwipeDynamicCaption, PhotoSwipe};
export {gsap};
export {Lenis};


